import { IInitConfig } from "common/interface/IInitConfig";

const STORAGE_KEY = "initConfig";

export const persistInitConfig = (config: IInitConfig) => {
  if (config) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  }
};

export const getPersistedInitConfig = (): IInitConfig | undefined => {
  const configString = localStorage.getItem(STORAGE_KEY);

  if (configString) {
    try {
      return JSON.parse(configString) as IInitConfig;
    } catch {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  return undefined;
};

export const removePersistedInitConfig = () => {
  localStorage.removeItem(STORAGE_KEY);
};
